import { useSelectedProjetId } from "../../../data/selectedProjet";
import { useOutgoingRequest } from "../../../data/tanstack-query";
import { getCurrentProject, getMe } from "../../../endpoints/outgoing-requests";

export function useMe() {
    return useOutgoingRequest(getMe());
}

export function useCurrentProject() {
    const projetId = useSelectedProjetId();
    return useOutgoingRequest(getCurrentProject(), [projetId]);
}
